"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
require("../styles/StoreAlertsDetails.scss");
var _StoreAlertsDetailsComponent = _interopRequireDefault(require("../components/StoreAlertsDetailsComponent"));
var _reactRouterDom = require("react-router-dom");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _Services = require("../common_features/utility/Services");
var _helper = require("../common_features/utility/helper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreAlertsDetails = () => {
  const {
    selectedStore
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const {
    systems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateways
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const {
    storeAlerts,
    selectedAlert
  } = (0, _reactRedux.useSelector)(state => state.alert);
  const [cAlert, setCAlert] = (0, _react.useState)({});
  const [device, setDevice] = (0, _react.useState)({});
  const [backButtonText, setBackButtonText] = (0, _react.useState)('');
  const [gotoDashboardtext, setGotoDashboardtext] = (0, _react.useState)('');
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [currentStore, setCurrentStore] = (0, _react.useState)({});
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const {
    userScreenPref
  } = (0, _reactRedux.useSelector)(state => state.role);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const handleBack = () => {
    navigate(-1);
  };
  const handleGotoDashboard = () => {
    if (userScreenPref) {
      if (userInfo.userType === 5) {
        navigate(_RoutePath.default.techDispatcher.useLink);
      } else {
        navigate(_RoutePath.default.storeDashboard.useLink);
      }
    } else {
      navigate(_RoutePath.default.admin.useLink);
    }
  };
  (0, _react.useEffect)(() => {
    setCurrentStore(selectedStore);
    return () => {};
  }, [selectedStore]);
  (0, _react.useEffect)(() => {
    setCAlert({
      ...selectedAlert
    });
    if (selectedAlert.isFromNotification) {
      if (["PRODUCT", "SYSTEM"].includes(selectedAlert.type)) {
        const data = selectedAlert;
        setCAlert({
          ...data,
          alarmText: data.text
        });
        if (data.systemId) {
          setIsLoading(true);
          (0, _Services.getStoreDetails)(data.storeId).then(async storeData => {
            (0, _Services.getSystemDetails)(data.systemId).then(res => {
              res = res.data;
              setIsLoading(false);
              setCurrentStore({
                ...storeData.data,
                address: (0, _helper.bindAddress)(JSON.parse(storeData.data.address))
              });
              setDevice(res.data);
              if (data.read === false || data.isRead === false) (0, _Services.markAsReadNotifications)([data.id]);
            });
          });
        } else if (data.deviceId) {
          gateways.forEach(element => {
            if (element.deviceId == data.deviceId) {
              setDevice(element);
            }
          });
          (data.read === false || data.isRead === false) && (0, _Services.markAsReadNotifications)([data.id]);
        }
        setGotoDashboardtext("Go to ".concat(userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? "Store" : "Home", " Dashboard"));
        setBackButtonText('General Alerts');
      } else if (selectedAlert.type === "GENERAL") {
        const data = selectedAlert;
        setCAlert({
          ...data,
          alarmText: data.text
        });
        setGotoDashboardtext("Go to ".concat(userScreenPref ? "Store" : "Home", " Dashboard"));
        setBackButtonText('General Alerts');
        if (selectedAlert.isRead === false || selectedAlert.read === false) (0, _Services.markAsReadNotifications)([selectedAlert.id]);
      }
    } else {
      if (selectedAlert.id) {
        if (selectedAlert.type === "PRODUCT") {
          const data = storeAlerts[selectedAlert.storeId].listItems[selectedAlert.id];
          setCAlert(data);
          if (data.systemId) {
            systems.forEach(element => {
              if (element.systemId == data.systemId) {
                setDevice(element);
              }
            });
          } else if (data.deviceId) {
            gateways.forEach(element => {
              if (element.deviceId == data.deviceId) {
                setDevice(element);
              }
            });
          }
          setBackButtonText('System Alert Detail');
          setGotoDashboardtext("Go to ".concat(userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? "Store" : "Home", " Dashboard"));
        } else {
          setGotoDashboardtext("Go to ".concat(userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? "Store" : "Home", " Dashboard"));
          setBackButtonText('General Alerts');
          if (selectedAlert.isRead === false || selectedAlert.read === false) (0, _Services.markAsReadNotifications)([storeAlerts.id]);
        }
      }
    }
  }, [selectedAlert]);
  return /*#__PURE__*/_react.default.createElement(_StoreAlertsDetailsComponent.default, {
    handleBack: handleBack,
    navHeadingText: backButtonText,
    SubNavHeadingText: "ALERT DETAIL",
    SubNavHeadingTitle: "ServiceConnect",
    selectedStore: currentStore,
    device: device,
    cAlert: cAlert,
    handleGotoDashboard: handleGotoDashboard,
    gotoDashboardtext: gotoDashboardtext,
    isLoading: isLoading
  });
};
var _default = exports.default = StoreAlertsDetails;